var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon",class:[_vm.type, _vm.size]},[_c('i',{class:[_vm.newPack, _vm.newPack === 'fa' ? ("fa-" + _vm.newIcon) : null ]},[_vm._v(_vm._s(_vm.newPack === 'mdi' ? _vm.newIcon : null))])])}
var staticRenderFns = []

export { render, staticRenderFns }